// Enhances the native <details> inside <footer-localization> with the
// disclosure UX a country picker needs: close on Escape, close on
// outside-click, focus the first interactive element in the panel on open.
//
// Wraps the existing Horizon <localization-form-component>, which handles
// list filtering, selection, and form submission. This element only owns
// the open/close shell.

class FooterLocalization extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    if (!this.details) return;
    this.summary = this.details.querySelector('summary');
    this.details.addEventListener('toggle', this.onToggle);
  }

  disconnectedCallback() {
    this.details?.removeEventListener('toggle', this.onToggle);
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeydown);
  }

  onToggle = () => {
    if (!this.details) return;
    if (this.details.open) {
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
      requestAnimationFrame(() => {
        const panel = this.querySelector('.footer-localization__panel');
        if (!panel) return;
        const focusable = panel.querySelector(
          'input, [tabindex]:not([tabindex="-1"]), button, [role="option"]'
        );
        focusable?.focus();
      });
    } else {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
    }
  };

  onDocumentClick = (event) => {
    if (!this.contains(event.target)) this.close();
  };

  onKeydown = (event) => {
    if (event.key === 'Escape' && this.details?.open) {
      event.preventDefault();
      event.stopPropagation();
      this.close();
      this.summary?.focus();
    }
  };

  close = () => {
    if (this.details) this.details.open = false;
  };
}

if (!customElements.get('footer-localization')) {
  customElements.define('footer-localization', FooterLocalization);
}
